<template>
    <div class="navigation">
        <div class="ham-wrap" :class="{'active' : sideMenu}">
            <a id="ham" class="ham" @click="sidemenu()">
                <div class="line"></div>
                <div class="line"></div>
            </a>
        </div>
        <div class="backcover" v-show="sideMenu" :class="{'active' : bgActive}">
            <div class="inner-contents" :class="{ 'active' : view }">
                <div class="nav-container">
                    <div class="logo-wrap">
                        <img src="@/assets/section-logo.svg" alt="栄養の日" class="logo">
                    </div>
                    <nav>
                        <ul>
                            <li class="main" :class="{'active' : pagename == 'top'}">
                                <a href="./">
                                    TOP
                                </a>
                            </li>
                            <li class="main" :class="{'active' : pagename === 'recipe' || pagename === 'movie' || pagename === 'about' }">
                                <a class="inner" href="./yobomeshi">「予防めし」</a>
                                <span class="sub" :class="{'active' : pagename == 'recipe'}">
                                    <a href="./yobomeshi">Instagramレシピ集</a>
                                </span>
                                <span class="sub" :class="{'active' : pagename == 'movie'}">
                                    <a href="./yobomeshi/movie">YouTube動画集</a>
                                </span>
                                <span class="sub" :class="{'active' : pagename == 'about'}">
                                    <a href="./yobomeshi/about">「予防めし」とは</a>
                                </span>
                            </li>
                            <li class="main"><a href="https://www.youtube.com/playlist?list=PLQSUnxiaJEopvwMPnzmWaSkf9k9v509pF" target="_blank">衛生管理術動画集</a></li>
                            <li class="main" :class="{'active' : pagename === 'open_lecture' }"><a href="./open_lecture">市民公開講座</a></li>
                            <li class="main"><a href="https://www.nutas.jp/84shindan/" target="_blank">栄養力診断</a></li>
                        </ul>
                    </nav>
                </div>
                <creditbar />
            </div>
        </div>
    </div>
</template>

<script>
import creditbar from '@/components/_credit.vue'
import Logo from '@/assets/logo.svg?inline'

export default {
    name: 'navigation',
    props:{
      pagename: String
    },
    components:{
        creditbar,
        Logo
    },
    data(){
        return{
            sideMenu: false,
            bgActive: false,
            view: false
        }
    },
    methods:{
        sidemenu(){
          if(this.sideMenu == false){
            this.sideMenu = true
            setTimeout(() => {
                this.bgActive = true
                this.view = true    
            }, 200);
          }
          else{
            this.bgActive = false
            this.view = false
            setTimeout(() => {
                this.sideMenu = false    
            }, 600);
          }
      }
    },
}
</script>

<style lang="scss" scoped>

$transition: 0.6s;

.backcover{
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    min-height: 720px;
    display: flex;
    flex-flow: column;
    align-items: center;
    justify-content: center;
    z-index: 1000;
    background: transparent;
    transition: $transition;
    &.active{
        transition: $transition;
        background: rgba($color: #fff, $alpha: .95);
        @supports ((-webkit-backdrop-filter: blur(20px)) or (backdrop-filter: blur(20px))) {
            background: rgba($color: #fff, $alpha: 0.4);    
            backdrop-filter: blur(20px);
        }  
    }
    @media #{$maxM}{
        min-height: 420px;
    }
}

.ham-wrap{
    display: block;
    width: 42px;
    height: 42px;
    position: absolute;
    top: $pc-gutter - 6px;
    right: $pc-gutter - 6px;
    z-index: 10000;
        #ham{
            padding: 6px;
            display: flex;
            flex-flow: column;
            justify-content: center;
            align-items: flex-start;
            position: relative;
            width: calc(100% - 12px);
            height: calc(100% - 12px);
                .line{
                    display: block;
                    position: absolute;
                    top: 8px;
                    width: calc(100% - 12px);
                    height: 2px;
                    background: $black;
                    transition: 0.4s;
                    &:last-child{
                        margin-top: 6px;
                    }
                }
        }
        &.active{
            #ham{
                .line{
                    top: 18px;
                    transform: rotate(45deg);
                    transform-origin: center;
                    &:last-child{
                        transform: rotate(-45deg);
                        margin-top: 0;
                    }
                }
            }
        }
}
.inner-contents{
    max-width: 900px;
    width: 100%;
    padding: 0 20px;
    overflow-y: scroll;
    opacity: 0;
    transition: 0.6s;
    transition-delay: 0.2s;
    @media #{$maxM}{
        margin-bottom: 72px;
    }
    &.active{
        opacity: 1;
        transition: 0.6s;
        transition-delay: 0.2s;
    }
        .nav-container{
            display: flex;
            flex-flow: row nowrap;
            justify-content: space-between;
            align-items: center;
            width: 100%;
            margin-bottom: 130px;
            @media #{$maxM}{
                flex-flow: column;
                justify-content: center;
                margin-bottom: 62px;
            }
                .logo-wrap{
                    width: 232px;
                    display: block;
                    padding: 0 126px 0 96px;
                    @media #{$maxM}{
                        width: 174px;
                        padding: 87px 0 48px;
                    }
                }
                nav{
                    display: flex;
                    flex-flow: column;
                    align-items: flex-start;
                    justify-content: flex-start;
                    width: 50%;
                    @media #{$maxM}{
                        width: auto;
                    }
                        ul{
                            display: flex;
                            flex-flow: column;
                            align-items: flex-start;
                            justify-content: flex-start; 
                            padding-left: 48px;
                            @media #{$maxM}{
                                padding-left: 48px;
                            }
                                li{
                                    display: flex;
                                    flex-flow: column;
                                    align-items: flex-start;
                                    justify-content: flex-start;
                                    margin-bottom: 40px;
                                    position: relative;
                                    @media #{$maxM}{
                                        margin-bottom: 20px;
                                    }
                                    &::before{
                                            content: '';
                                            width: 21px;
                                            height: 3px;
                                            background: $yellow;
                                            position: absolute;
                                            top: 0.5em;
                                            left: 0;
                                            opacity: 0;
                                            transition: 0.2s;
                                            @media #{$maxM}{
                                                width: 14px;
                                            }
                                    }

                                    &:last-child{
                                        margin-bottom: 0;
                                    }

                                    &.active,
                                    &:hover{
                                        &::before{
                                            opacity: 1;
                                            left: -42px;
                                            @media #{$maxM}{
                                                left: -24px;
                                            }
                                        }
                                    }

                                    &.main{
                                        font-size: 1.875em;
                                        @media #{$maxM}{
                                            font-size: 1.429em;
                                        }
                                    }
                                    .inner{
                                        margin-left: -0.5em;
                                        margin-bottom: 16px;
                                    }
                                        span.sub{
                                            font-size: 0.5em;
                                            padding-left: 4em;
                                            margin-bottom: 12px;
                                            @media #{$maxM}{
                                                font-size: 0.75em;
                                                padding-left: 1.5em;
                                            }
                                            position: relative;
                                            &:last-child{
                                                margin-left: -0.5em;
                                                margin-bottom: 0;
                                            }
                                            &::before{
                                                content: '';
                                                width: 21px;
                                                height: 3px;
                                                background: $yellow;
                                                position: absolute;
                                                top: 0.5em;
                                                left: 0;
                                                opacity: 0;
                                                transition: 0.2s;
                                                @media #{$maxM}{
                                                    width: 10px;
                                                }
                                            }
                                            &.active,
                                            &:hover{
                                                &::before{
                                                    left: 20px;
                                                    opacity: 1;
                                                    @media #{$maxM}{
                                                        left: 0;
                                                    }
                                                }
                                            }
                                        }
                                }
                        }
                }
        }
}
.credit-bar{
    justify-content: space-between;
    @media #{$maxM}{
        max-width: 460px;
        margin: 0 auto;
    }
}
.comming_soon {
    color: #959595;
    pointer-events: none;
}
</style>